// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-sub-menu-flyout-card {
  z-index: 10;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 644px;
  padding: calc(1.5rem);
  background: #fff;
  border: 1px solid #e5e6e6;
  border-radius: 0.5rem;
  box-shadow: 0 3px 12px rgb(0, 0, 0, 0.2);
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
